// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});

Vue.config.productionTip = false;

import "../node_modules/swiper/dist/css/swiper.min.css"
import "../node_modules/swiper/dist/js/swiper.min.js"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js